import { render, staticRenderFns } from "./DegreePage.vue?vue&type=template&id=59c6250d"
import script from "./DegreePage.vue?vue&type=script&lang=js"
export * from "./DegreePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports